<template>
    <div id="searchable-health-post" class="container">
        <div class="row justify-content-center">
            <div class="col-md-9 mb-3"></div>
            <div class="col-md-3 text-right back-btn__mobile">
                <a id='back-button' class="btn btn-primary btn-sb-red" href="/searchable-health-library" title="Redirect to Library Page">Back to Searchable Health Library</a>
            </div>
        </div>
        <h1 class="wk-section-heading">{{ title }}</h1>
        <p>{{ summary  }}</p>
        <div class="video-container">
            <iframe id="searchable-health-post-video" v-bind:src="video" allowfullscreen frameBorder="0" class="video-iframe"></iframe>
        </div>



    </div>
</template>
<style>
.wk-section-heading {
    margin-top: 15px;
    text-align: left;
    font: normal normal normal 25px Roboto;
    letter-spacing: 0px;
    color: #1D2D5B;
    text-transform: uppercase;
}
.video-container {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
}
.video-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>

<script>
export default {
    name: "SBSearchableHealthLibraryVideo",
    props: {
        video: String,
        summary: String,
        title: String,
    },
    data() {
        return {}
    },
    methods: {},
}
</script>

<style scoped>

</style>
